import { useEffect, useState, useCallback, useMemo } from 'react';
import { SESSION_STORAGE_KEYS, CACHE_DEFAULTS } from 'frontend/constants';
import { useFlightContext } from 'frontend/contexts/FlightDetailsContext';

const { CACHE_STATUS } = SESSION_STORAGE_KEYS;

export const useRefreshModal = () => {
  const [showRefreshModal, setShowRefreshModal] = useState(false);
  const { expCacheDate } = useFlightContext();
  const [hasExpired, setHasExpired] = useState(false);

  const timeUntilExpiration = useMemo(
    () =>
      expCacheDate
        ? new Date(expCacheDate).getTime() - Date.now()
        : CACHE_DEFAULTS.DEFAULT_EXPIRATION_TIME,
    [expCacheDate],
  );

  // Inicializar el estado del cache
  useEffect(() => {
    if (!window.sessionStorage.getItem(CACHE_STATUS)) {
      window.sessionStorage.setItem(CACHE_STATUS, 'true');
    }
    setHasExpired(false);
  }, [expCacheDate]);

  const handleRefreshConfirm = useCallback((onRefresh) => {
    setShowRefreshModal(false);
    
    if (onRefresh) {
      window.sessionStorage.setItem(CACHE_STATUS, 'false');
      onRefresh();
    }
  }, []);

  useEffect(() => {
    if (!expCacheDate || hasExpired || timeUntilExpiration <= 0) return;

    const timerId = setTimeout(() => {
      setShowRefreshModal(true);
      setHasExpired(true);
      window.sessionStorage.setItem(CACHE_STATUS, 'false');
    }, timeUntilExpiration);

    return () => {
      clearTimeout(timerId);
    };
  }, [expCacheDate, timeUntilExpiration, hasExpired]);

  return {
    showRefreshModal,
    setShowRefreshModal,
    handleRefreshConfirm,
  };
};
